import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from '@date-io/date-fns';
import { fr } from "date-fns/locale";
import '../Css/cherche.css';
import { Link } from "react-router-dom";
import { toast } from 'react-toastify';
import { TypeCuisineRequest } from '../Api/HomeApi';

const Recherche = ({ ou, qoui, datePrise, heurePrise, personnePrise }) => {
  const [sansDate, setSansDate] = useState(false);
  const [dataCuisine, setDataCuisine] = useState([]);
  const [isMounted, setIsMounted] = useState(true);
  const [ouValue, setOuValue] = useState(ou !== "..." && ou !== "" ? ou : '');
  const [cuisineValue, setCuisineValue] = useState(qoui !== "" && qoui !== "..." ? qoui : '');
  const [heureValue, setHeureValue] = useState(heurePrise !== "" && heurePrise !== "..." && sansDate !== true ? heurePrise : '');
  const [date, setDate] = useState(datePrise !== "" && datePrise !== "..." && sansDate !== true ? new Date(datePrise) : new Date());
  const [personneValue, setPersonneValue] = useState(personnePrise !== "" && personnePrise !== "..." && sansDate !== true ? personnePrise : '');

  const [activeDate, setActiveDate] = useState(datePrise !== "" ? true : false);

  console.log("ou Cherche=>", ou);

  console.log("qoui Cherche=>", qoui);

  console.log("datePrise Cherche=>", new Date(datePrise));

  console.log("heurePrise Cherche=>", heurePrise);

  console.log("personnePrise=> Cherche", personnePrise);



  const heure = [
    { value: '05:00', label: '05H:00' },
    { value: '05:30', label: '05H:30' },
    { value: '06:00', label: '06H:00' },
    { value: '06:30', label: '06H:30' },
    { value: '07:00', label: '07H:00' },
    { value: '07:30', label: '07H:30' },
    { value: '08:00', label: '08H:00' },
    { value: '08:30', label: '08H:30' },
    { value: '09:00', label: '09H:00' },
    { value: '09:30', label: '09H:30' },
    { value: '10:00', label: '10H:00' },
    { value: '10:30', label: '10H:30' },
    { value: '11:00', label: '11H:00' },
    { value: '11:30', label: '11H:30' },
    { value: '12:00', label: '12H:00' },
    { value: '12:30', label: '12H:30' },
    { value: '13:00', label: '13H:00' },
    { value: '13:30', label: '13H:30' },
    { value: '14:00', label: '14H:00' },
    { value: '14:30', label: '14H:30' },
    { value: '15:00', label: '15H:00' },
    { value: '15:30', label: '15H:30' },
    { value: '16:00', label: '16H:00' },
    { value: '16:30', label: '16H:30' },
    { value: '17:00', label: '17H:00' },
    { value: '17:30', label: '17H:30' },
    { value: '18:00', label: '18H:00' },
    { value: '18:30', label: '18H:30' },
    { value: '19:00', label: '19H:00' },
    { value: '19:30', label: '19H:30' },
    { value: '20:00', label: '20H:00' },
    { value: '20:30', label: '20H:30' },
    { value: '21:00', label: '21H:00' },
    { value: '21:30', label: '21H:30' },
    { value: '22:00', label: '22H:00' },
    { value: '22:30', label: '22H:30' },
    { value: '23:00', label: '23H:00' },
    { value: '23:30', label: '23H:30' },
  ];
  const personne = [
    { value: '', label: 'Personne ...' },
    { value: '1', label: 'Pour 1 personne' },
    { value: '2', label: 'Pour 2 personnes' },
    { value: '3', label: 'Pour 3 personnes' },
    { value: '4', label: 'Pour 4 personnes' },
    { value: '5', label: 'Pour 5 personnes' },
    { value: '6', label: 'Pour 6 personnes' },
    { value: '7', label: 'Pour 7 personnes' },
    { value: '8', label: 'Pour 8 personnes' },
    { value: '9', label: 'Pour 9 personnes' },
    { value: '10', label: 'Pour 10 personnes' },
    { value: '11', label: 'Pour +10 personnes' },
  ];

  useEffect(() => {
    TypeCuisineRequest().then(function (response) {
      console.log('TypeCuisine=>', response.data.donner);
      if (isMounted) { // Vérifier si le composant est toujours monté
        response.data.donner?.map((item) => {
          return setDataCuisine((prev) => [...prev, { value: item.libelle, label: item.libelle }]);
        });
      }
    }).catch(function (error) {
      console.log(error);
    });

    // Nettoyer les tâches asynchrones dans la fonction de nettoyage useEffect
    return () => {
      setIsMounted(false); // Mettre à jour le drapeau lorsque le composant est démonté
    };
  }, [isMounted]);


  const handleSansDate = () => {
    setActiveDate(false);
    setSansDate(!sansDate);
    setPersonneValue('');
    setHeureValue('');
    setDate(new Date());
  }

  const handleChangeDate = (date) => {
    setDate(new Date(date));
    setActiveDate(true);
    setSansDate(false);
  }
  const format = (value) => {
    if (value < 10) {
      return "0" + value;
    } else {
      return value;
    }
  }


  const formateDate = (value) => {
    return new Date(value).getFullYear() + "-" + format(parseInt(new Date(value).getUTCMonth() + 1)) + "-" + format(new Date(value).getDate());
  }


  const handlePersonne = (e) => {
    setActiveDate(true);
    setSansDate(false);
    setPersonneValue(e.value);
  }

  const handleHeure = (e) => {
    setActiveDate(true);
    setSansDate(false);
    setHeureValue(e.value)
  }


  const handleAvecCritere = (event) => {

    if (date === "" || heureValue === "" || personneValue === "") {
      toast.success("Si vous utiliser la recherche avec critère vous devez remplir la date , l'heure et le nombre de personne");
      event.preventDefault();
      localStorage.removeItem('urlCritere');
      localStorage.removeItem('urlCritereHeure');
      localStorage.removeItem('urlCritereDate');
    } else {
      localStorage.setItem('urlCritere', `/restaurant/${ouValue !== "" ? ouValue : "..."}/${cuisineValue !== "" ? cuisineValue : "..."}/${date !== "" ? formateDate(date) : "..."}/${heureValue !== "" ? heureValue : "..."}/${personneValue !== "" ? personneValue : "..."}`);
      localStorage.setItem('urlCritereHeure', `/restaurant/${ouValue !== "" ? ouValue : "..."}/${cuisineValue !== "" ? cuisineValue : "..."}/${date !== "" ? formateDate(date) : "..."}/${heureValue !== "" ? heureValue : "..."}`);
      localStorage.setItem('urlCritereDate', `/restaurant/${ouValue !== "" ? ouValue : "..."}/${cuisineValue !== "" ? cuisineValue : "..."}/${date !== "" ? formateDate(date) : "..."}`);
    }

  }



  return (
    <div className='cherche'>
      <div className="row">
        <div className='col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4'>
          <div className='bloc1'>
            <div className='bloc1_champ'>
              <span className='titre_champ'>Où</span>
              <input className='form-control' value={ouValue} onChange={(e) => setOuValue(e.target.value)} placeholder='Restaurant, quartier ...' />
            </div>
            <div className='bloc1_select'>
              <span className='titre_champ'>Quoi</span>
              <Select
                placeholder={qoui !== "" && qoui !== "..." ? qoui : "Cuisine ..."}
                onChange={(e) => setCuisineValue(e.value)}
                options={dataCuisine} />
            </div>
          </div>
        </div>

        <div className='col-12 col-sm-12 col-md-8 col-lg-7 col-xl-7'>
          <div className='bloc2'>
            <div className="form-check form_check1">
              <input className="form-check-input" type="checkbox" checked={sansDate} onChange={() => handleSansDate()} id="flexCheckDefault" />
              <label className="form-check-label" htmlFor="flexCheckDefault">
                Sans date précise
              </label>
            </div>
            <div className='bloc2_date'>
              <div><span className='titre_champ'>Quand</span></div>
              <MuiPickersUtilsProvider locale={fr} utils={DateFnsUtils}>
                <KeyboardDatePicker
                  value={date}
                  placeholder="00/00/0000"
                  onChange={date => handleChangeDate(date)}
                  minDate={new Date()}
                  format="dd/MM/yyyy"
                />
              </MuiPickersUtilsProvider>
            </div>
            <div className='bloc2_heure'>
              <Select
                placeholder={heurePrise !== "" && heurePrise !== "..." && sansDate !== true ? heurePrise : "Heure ..."}
                onChange={(e) => handleHeure(e)}

                options={heure} />


            </div>
            <div className='responsive_recherche'>
              <div className='responsive_bloc1'>
                <div className="form-check">
                  <input className="form-check-input" type="checkbox" checked={sansDate} onChange={() => handleSansDate()} id="flexCheckDefault" />
                  <label className="form-check-label" htmlFor="flexCheckDefault">
                    Sans date précise
                  </label>
                </div>
                <div className='bloc2_date'>
                  <span className='titre_champ'>Quand</span>
                  <MuiPickersUtilsProvider locale={fr} utils={DateFnsUtils}>
                    <KeyboardDatePicker
                      value={date}
                      placeholder="00/00/0000"
                      onChange={date => handleChangeDate(date)}
                      minDate={new Date()}
                      format="dd/MM/yyyy"
                    />
                  </MuiPickersUtilsProvider>
                </div>
              </div>
              <div className='bloc2_heure'>
                <Select
                  placeholder={heurePrise !== "" && heurePrise !== "..." && sansDate !== true ? heurePrise : "Heure ..."}
                  onChange={(e) => handleHeure(e)}
                  options={heure} />
              </div>
            </div>
            <div className='bloc2_personne'>
              <span className='titre_champ'>Combien</span>
              <Select
                placeholder={personnePrise !== "" && personnePrise !== "..." && sansDate !== true ? personnePrise : "Personne ..."}
                onChange={(e) => handlePersonne(e)}
                options={personne} />
            </div>
            <div className='responsive_recherche_2'>
              <div className='bloc2_personne'>
                <span className='titre_champ mb-1'>Combien</span>
                <Select
                  placeholder={personnePrise !== "" && personnePrise !== "..." && sansDate !== true ? personnePrise : "Personne ..."}
                  onChange={(e) => handlePersonne(e)}
                  options={personne} />
              </div>
              <div className='bloc3'>
                {sansDate === true || activeDate !== true ?
                  <Link to={`/restaurant/${ouValue !== "" ? ouValue : "..."}/${cuisineValue !== "" ? cuisineValue : "..."}`} refresh="true"><button className='btn' >
                    Rechercher
                  </button></Link>
                  :
                  <Link to={`/restaurant/${ouValue !== "" ? ouValue : "..."}/${cuisineValue !== "" ? cuisineValue : "..."}/${date !== "" ? formateDate(date) : "..."}/${heureValue !== "" ? heureValue : "..."}/${personneValue !== "" ? personneValue : "..."}`} onClick={handleAvecCritere}><button className='btn'>
                    Rechercher
                  </button></Link>
                }

              </div>
            </div>
          </div>
        </div>
        <div className='col-12 col-sm-12 col-md-4 col-lg-1 col-xl-1'>
          <div className='bloc3'>
            {sansDate === true || activeDate !== true ?
              <Link to={`/restaurant/${ouValue !== "" ? ouValue : "..."}/${cuisineValue !== "" ? cuisineValue : "..."}`} refresh="true"><button className='btn'>
                Rechercher
              </button></Link>
              :
              <Link to={`/restaurant/${ouValue !== "" ? ouValue : "..."}/${cuisineValue !== "" ? cuisineValue : "..."}/${date !== "" ? formateDate(date) : "..."}/${heureValue !== "" ? heureValue : "..."}/${personneValue !== "" ? personneValue : "..."}`} onClick={handleAvecCritere} refresh="true"><button className='btn'>
                Rechercher
              </button></Link>
            }


          </div>
        </div>
      </div>



    </div>
  )
}

export default Recherche